import "./styles.css"

export function ScrollArrow({ href, label }: { href: string; label: string }) {
  return (
    <div className="scroll-for-more">
      <a
        href={href}
        aria-label={label}
      >
        <span className="parent">
          <span className="child" />
        </span>
      </a>
    </div>
  )
}

export default ScrollArrow
